export const environment = {
  production: false,
  appVersion: window['env']['appVersion'],
  appVersionDate: window['env']['appVersionDate'],
  refreshToken: false,
  portalUrl: window['env']['portalUrl'],
  mt_userProfileEndpoint: window['env']['mt_userProfileEndpoint'],
  ekrsApiUrl: window['env']['ekrsApiUrl'],
  apkKrsUrl: window['env']['apkKrsUrl'],
  wyszukiwarkaUrl: window['env']['wyszukiwarkaUrl'],
  notificationUrl: window["env"]["notificationUrl"],
  secretKey: window['env']['secretKey'],
  newsletterKomunikatNaglowek: window['env']['newsletterKomunikatNaglowek'],
  newsletterKomunikatTresc: window['env']['newsletterKomunikatTresc'],
  mt: {
    config: {
      issuer: window['env']['mt_issuer'],
      realm: window['env']['mt_realm'],
      clientId: window['env']['mt_clientId'],
      scope: window['env']['mt_scope'],
      redirectUri: window['env']['mt_redirectUri'] || window.location.origin,
      postLogoutRedirectUri: window['env']['mt_postLogoutRedirectUri'],
      responseType: window['env']['mt_responseType'],
      userProfileEndpoint: window['env']['mt_userProfileEndpoint']
    },
    allowedUrls: []
  },
  signalRUrl: window['env']['signalRUrl']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
